export default __webpack_public_path__ + "static/media/logoutIconInverted.18c39c25.svg";